var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scrollable-list',{ref:"slider",attrs:{"items":_vm.cardItems},on:{"init":_vm.initNavigationButtons,"slideChange":_vm.handleSlideChange,"transitionStart":_vm.handleTransitionStart,"updated":_vm.initNavigationButtons}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061bde40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Booking/Card/List.vue
// module id = null
// module chunks = 